import { Modal } from "@mantine/core";
import { BiLoaderAlt } from "react-icons/bi";
import { MdOutlineCampaign } from "react-icons/md";

const ConfirmationCampaign = ({
  opened,
  setOpend,
  title,
  handler,
  loading,
}) => {
  const close = () => {
    setOpend(false);
  };

  return (
    <div>
      <Modal
        centered
        opened={opened}
        onClose={() => close()}
        title={title}
        overlayProps={{
          backgroundOpacity: 0.1,
          // blur: 3,
        }}
      >
        <div className='my-8 text-center'>
          <MdOutlineCampaign className='text-6xl m-auto text-red-600' />
          <h4 className='mt-4 text-lg font-semibold text-gray-800'>
            Are you sure you want to run campaign it?
          </h4>
        </div>
        <div className='flex flex-col space-y-2'>
          <button
            type='button'
            onClick={handler}
            disabled={loading}
            className='rounded-lg bg-red-500 px-4 py-2 text-sm tracking-wide text-white hover:bg-red-600 active:bg-red-500'
          >
            {loading ? (
              <BiLoaderAlt className='m-auto animate-spin text-center text-xl text-white' />
            ) : (
              "Run Campaign"
            )}
          </button>
          <button
            type='button'
            onClick={() => close()}
            className='rounded-lg bg-gray-200 px-4 py-2 text-sm tracking-wide text-gray-800 hover:bg-gray-300 active:bg-gray-200'
          >
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default ConfirmationCampaign;
